import {stackManager} from "../class/StackManager";

export function useStackRouter() {
    return stackManager
}
